import { useCallback, useEffect, useState } from 'react';
import { OptionType } from './Select.types';

const useOptionsCache = (initialOptions?: OptionType[]) => {
  const [optionsCache, setOptionsCache] = useState(new Map());
  const [options, setOptions] = useState<OptionType[] | undefined>([]);

  const dedupWithPrev = useCallback(
    (o?: OptionType[]) =>
      o
        ? o.map((option) => {
            const hash = option.value;
            const cached = optionsCache.get(hash);

            if (cached) {
              return cached;
            }

            setOptionsCache((prev) => new Map(prev.set(hash, option)));
            return option;
          })
        : o,
    [optionsCache]
  );

  useEffect(() => {
    setOptions(dedupWithPrev(initialOptions));
  }, [dedupWithPrev, initialOptions]);

  return [options];
};

export default useOptionsCache;
